import styles from "./index.module.css";

type Props = {
  messageId?: string;
  supportId?: string;
  dates?: string;
  className?: string;
};
export const SessionExtra = ({ dates, messageId, supportId, className }: Props) => {
  return (
    <>
      <div className={`${styles.selectedSession} ${className ?? ""}`}>
        {messageId ? (
          <div className={styles.infoWrapper}>
            <span>Message ID</span>
            <span>{messageId}</span>
          </div>
        ) : null}
        {supportId ? (
          <div className={styles.infoWrapper}>
            <span>Support ID</span>
            <span>{supportId}</span>
          </div>
        ) : null}
        {dates ? (
          <div className={styles.infoWrapper}>
            <span>Dates</span>
            {/* <span>{new Date().toLocaleString("en-EN", { month: "short", day: "2-digit" })}</span> */}
            <span>{dates}</span>
          </div>
        ) : null}
      </div>
    </>
  );
};
